import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from './theme'
import { Body, Footer, Header } from './view/components'

import { Routing } from './view/Routing'
import { ConfigProvider } from './view/components/ConfigProvider'
import { ApplicationBackground, Disconnected } from './view/components/widgets'

export default function App () {
  return (
    <ThemeProvider>
      <BrowserRouter>
          <Header />
          <Body>
            <ConfigProvider>
              <Routing />
            </ConfigProvider>
          </Body>
          <Disconnected />
          <ApplicationBackground />
          <Footer />
      </BrowserRouter>
    </ThemeProvider>
  )
}
